// extracted by mini-css-extract-plugin
module.exports = {"ProductTag":"styles_ProductTag__gj5nQ"};